import { render, staticRenderFns } from "./DashboardCalendarList.vue?vue&type=template&id=c1d472c2"
import script from "./DashboardCalendarList.vue?vue&type=script&lang=js"
export * from "./DashboardCalendarList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports